import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { LOGO_LOGIN, LOGO_FOOTER } from '../logos';

export default function Login() {
  const { login } = useAuth();
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const submit = () => {
    setError('');
    const r = login(usuario, password);
    if (!r.ok) setError(r.error);
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#f0f4f8',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '16px 16px 76px'
    }}>
      <div className="card" style={{ width: '100%', maxWidth: 400, padding: '34px 30px' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 26 }}>
          <img src={LOGO_LOGIN} alt="Acrox Assistant" style={{ height: 52 }} />
        </div>
        <div style={{ textAlign: 'center', marginBottom: 22 }}>
          <div style={{ fontWeight: 800, fontSize: 18, color: '#0f172a' }}>ACERO &amp; CRISTAL MTY</div>
          <div style={{ fontSize: 13, color: '#94a3b8', marginTop: 4 }}>Inicia sesión para continuar</div>
        </div>

        <label style={{ fontSize: 13, fontWeight: 600, color: '#475569' }}>Usuario</label>
        <input
          type="text"
          value={usuario}
          onChange={e => setUsuario(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && submit()}
          placeholder="usuario o correo"
          style={{ margin: '6px 0 14px' }}
          autoFocus
        />

        <label style={{ fontSize: 13, fontWeight: 600, color: '#475569' }}>Contraseña</label>
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && submit()}
          placeholder="••••••••"
          style={{ margin: '6px 0 18px' }}
        />

        {error && (
          <div style={{
            background: '#fee2e2', color: '#dc2626', borderRadius: 8,
            padding: '8px 12px', fontSize: 13, fontWeight: 600, marginBottom: 14
          }}>
            {error}
          </div>
        )}

        <button className="btn-primary" onClick={submit} style={{ width: '100%', padding: 11 }}>
          Entrar
        </button>
      </div>

      <footer style={{
        position: 'fixed', left: 0, right: 0, bottom: 0, height: 44,
        background: '#185fa5', display: 'flex', alignItems: 'center',
        justifyContent: 'center', zIndex: 200
      }}>
        <img src={LOGO_FOOTER} alt="Acrox Assistant" style={{ height: 23 }} />
      </footer>
    </div>
  );
}
